export const API_URL = "https://xjqbd2cssz.ap-southeast-1.awsapprunner.com";
